<template>
  <div>
    <!--<h3 class="title">费用收取</h3>-->
    <div class="margin-bottom-10 header-group">
      <Select v-model="params.CondList[0].Key" @on-change="change_condList">
        <Option
          v-for="(item,index) in d_search_key"
          :value="item.value"
          :key="index"
        >{{ item.label }}</Option>
      </Select>
      <Select
        v-model="params.CondList[0].Operator"
        v-if="params.CondList[0].Key==='p.Money' || params.CondList[0].Key==='p.Yue' || params.CondList[0].Key==='p.MoneyDate' || params.CondList[0].Key==='p.PaperDate' "
      >
        <Option value=">=" label="大于等于"></Option>
        <Option value="<=" label="小于等于"></Option>
      </Select>

      <Select v-model="params.CondList[0].Value" v-if="params.CondList[0].Key==='p.ShouTuiType'">
        <Option label="收款" value="收款"></Option>
        <Option label="退款" value="退款"></Option>
        <Option label="无" value="无"></Option>
      </Select>
      <Select
        v-model="params.CondList[0].Value"
        v-else-if="params.CondList[0].Key==='p.NormalType'"
      >
        <Option label="正常" value="正常"></Option>
        <Option label="挂账" value="挂账"></Option>
        <Option label="补账" value="补账"></Option>
      </Select>
      <Select
        v-model="params.CondList[0].Value"
        v-else-if="params.CondList[0].Key==='p.PayWayType'"
      >
        <Option label="银行" value="银行"></Option>
        <Option label="现金" value="现金"></Option>
        <Option label="POS" value="POS"></Option>
        <Option label="其他" value="其他"></Option>
        <Option label="无" value="无"></Option>
      </Select>
      <DatePicker
        type="date"
        placeholder="请选择日期"
        @on-change="change_LastPayDate"
        v-else-if="params.CondList[0].Key==='p.MoneyDate' || params.CondList[0].Key==='p.PaperDate'"
      ></DatePicker>
      <Input v-model="params.CondList[0].Value" placeholder="请输入搜索内容" v-else />
      <Button type="primary" @click="search()">查询</Button>
      <Button type="primary" @click="to_add()" class="right">新增</Button>
    </div>
    <Table :columns="d_columns" border :data="d_data" @on-selection-change="get_select_data"></Table>
    <div class="margin-top-20">
      <Page
        :total="d_total"
        show-sizer
        show-total
        @on-change="flip"
        @on-page-size-change="change_size"
        class="pull-right"
      ></Page>
      <div class="clear-both"></div>
    </div>
    <Modal v-model="d_modal_add" :title="d_modal_title" width="760px" footer-hide>
      <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="100">
        <Row :gutter="5">
          <Col span="24">
            <FormItem label="选择合同" prop="ContractID">
              <Button
                type="primary"
                shape="circle"
                icon="ios-add"
                @click="to_openContract"
                v-if="d_modal_type==='add'"
              ></Button>
              <span
                v-if="add_params.ContractID!=''"
                class="margin-left10"
              >已选合同：{{ add_params.ContractName || add_params.ContractID }}</span>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="收款类型" prop="NormalType">
              <Select v-model="add_params.NormalType" style="width: 200px;">
                <Option v-for="item in d_NormalType_arr" :value="item" :key="item">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否开具发票" prop="IsInvoice">
              <RadioGroup v-model="add_params.IsInvoice">
                <Radio label="是">是</Radio>
                <Radio label="否" :disabled="add_params.NormalType==='正常'?true:false">否</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="收款方式" prop="PayWayType">
              <RadioGroup
                v-model="add_params.PayWayType"
                size="small"
                v-if="add_params.NormalType!=='正常' && add_params.IsInvoice==='是'"
              >
                <Radio label="无"></Radio>
              </RadioGroup>
              <Select
                v-model="add_params.PayWayType"
                style="width: 200px;"
                v-if="(add_params.NormalType!=='正常' && add_params.IsInvoice==='否') || add_params.NormalType==='正常'"
              >
                <Option v-for="item in d_PayWayType_list" :value="item" :key="item">{{ item }}</Option>
              </Select>
              <!--<Select v-model="add_params.PayWayType" style="width: 200px;" v-else>-->
              <!--<Option v-for="item in d_PayWayType_list" :value="item" :key="item">{{ item }}</Option>-->
              <!--<Option value="无" label="无"></Option>-->
              <!--</Select>-->
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="收款退款" prop="ShouTuiType">
              <RadioGroup
                v-model="add_params.ShouTuiType"
                size="small"
                v-if="add_params.NormalType!=='正常' && add_params.IsInvoice==='是'"
              >
                <Radio label="无"></Radio>
              </RadioGroup>
              <RadioGroup
                v-model="add_params.ShouTuiType"
                size="small"
                v-if="add_params.NormalType!=='正常' && add_params.IsInvoice==='否'"
              >
                <Radio label="收款"></Radio>
              </RadioGroup>
              <RadioGroup
                v-model="add_params.ShouTuiType"
                size="small"
                v-if="add_params.NormalType==='正常'"
              >
                <Radio label="收款"></Radio>
                <Radio label="退款"></Radio>
              </RadioGroup>
              <!--<RadioGroup v-model="add_params.ShouTuiType" size="small" v-else>-->
              <!--<Radio label="收款"></Radio>-->
              <!--<Radio label="退款"></Radio>-->
              <!--<Radio label="无"></Radio>-->
              <!--</RadioGroup>-->
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem label="凭证日期" prop="PaperDate">
              <DatePicker
                type="date"
                style="width: 200px;"
                :value="add_params.PaperDate"
                @on-change="change_date_paper"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="收支日期" prop="MoneyDate">
              <DatePicker
                type="date"
                style="width: 200px;"
                :value="add_params.MoneyDate"
                @on-change="change_date_money"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Card>
          <Row :gutter="10">
            <Col span="12">
              <FormItem label="选择科目" prop="XiaoXiang">
                <Col span="12">
                  <Select
                    v-model="XiaoXiangFather"
                    @on-change="change_xiaoxiangFather"
                    style="padding-right: 1px;"
                  >
                    <Option
                      v-for="item in d_XiaoXiangFather_arr"
                      :value="item"
                      :key="item"
                    >{{ item }}</Option>
                  </Select>
                </Col>
                <Col span="12">
                  <Select
                    v-model="add_params.XiaoXiang"
                    :disabled="d_XiaoXiang_arr.length>0?false:true"
                  >
                    <Option
                      v-for="item in d_XiaoXiang_arr"
                      :value="item.value"
                      :key="item.label"
                    >{{ item.label }}</Option>
                  </Select>
                </Col>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="单项金额" prop="Money">
                <Input v-model="add_params.Money" class="margin-right10" style="width: 100px;"></Input>元
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem
                label="税率"
                v-if="add_params.NormalType==='挂账' && add_params.IsInvoice==='否'"
              >
                <span>0%</span>
              </FormItem>
              <FormItem label="税率" prop="TaxRate" v-else>
                <Select v-model="add_params.TaxRate" style="width: 200px;">
                  <Option v-for="item in d_rate_list" :value="item" :key="item">{{ item }}%</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Card>
        <br />
        <FormItem label="负责人" prop="Agent">
          <Input v-model="add_params.Agent" placeholder="请输入负责人" style="width: 200px;"></Input>
        </FormItem>
        <FormItem label="备注" prop="Notes">
          <Input v-model="add_params.Notes" type="textarea" placeholder="请输入备注" />
        </FormItem>
        <FormItem label="附件票据" prop="photos1" style="height: auto;">
          <Upload
            ref="IDImgList"
            :default-file-list="d_defaultList_ID"
            :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=pay&&type=费用票据附件'"
            multiple
            :headers="{Authorization:token}"
            :on-preview="img_preview"
          >
            <Button icon="ios-cloud-upload-outline">请选择文件</Button>
          </Upload>
        </FormItem>
        <Modal v-model="d_modal_contract" title="选择所属合同" footer-hide>
          <div class="margin-bottom-10 header-group">
            <Select v-model="contract_params.CondList[0].Key" @on-change="change_condList_contract">
              <Option
                v-for="(item,index) in d_search_key_contract"
                :value="item.value"
                :key="index"
              >{{ item.label }}</Option>
            </Select>
            <Input v-model="contract_params.CondList[0].Value" placeholder="请输入搜索内容" />
            <Button type="primary" @click="search_contract()">查询</Button>
          </div>
          <Table
            highlight-row
            border
            ref="currentRowTable"
            height="400"
            :columns="d_columns_contract"
            :data="d_data_contract"
            @on-current-change="change_contract"
          ></Table>
        </Modal>
        <FormItem>
          <Button type="primary" @click="edit_confirm('formValidate')">保存</Button>
          <Button @click="add_modal_cancel" class="margin-left10">取消</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="d_modal_detail" title="查看详情" footer-hide>
      <div class="detail-group">
        <!--<section><label>收支类型：</label><span>{{ d_data_detail.Type }}</span></section>-->
        <section>
          <label>收款方式：</label>
          <span>{{ d_data_detail.PayType }}</span>
        </section>
        <section>
          <label>是否开票：</label>
          <span>{{ d_data_detail.IsInvoice }}</span>
        </section>
        <section>
          <label>收支日期：</label>
          <span>{{ d_data_detail.MoneyDate }}</span>
        </section>
        <section>
          <label>凭证日期：</label>
          <span>{{ d_data_detail.PaperDate }}</span>
        </section>
        <section>
          <label>金额：</label>
          <span>￥{{ d_data_detail.Money }}</span>
        </section>
        <section>
          <label>负责人：</label>
          <span>{{ d_data_detail.Agent }}</span>
        </section>
        <section>
          <label class="pull-left">备注：</label>
          <div class="pull-left">{{ d_data_detail.Notes }}</div>
          <div class="clear-both"></div>
        </section>
        <section>
          <label class="pull-left">附件票据：</label>
          <div class="pull-left">
            <a>
              <img :src="d_detail_file" @click="img_preview_detail" class="tx-user" />
            </a>
          </div>
          <div class="clear-both"></div>
        </section>
      </div>
    </Modal>
    <Modal title="图片预览" v-model="d_img_visible" @on-cancel="cancel_preview" footer-hide>
      <img :src="d_img_name" v-if="d_img_visible" style="width: 100%" />
    </Modal>
  </div>
</template>
<script>
import apiPay from "@/api/pay.js";
import apiContract from "@/api/contract.js";
import apiPublic from "@/api/public.js";
import apiSystem from "@/api/system.js";
import mixin from "@/components/common/mixin.js";
export default {
  name: "cost_gather",
  mixins: [mixin],
  data() {
    return {
      token: "",
      params: {},
      add_params: {},
      d_XiaoXiang_arr: [],
      XiaoXiangFather: "",
      d_XiaoXiangFather_arr: ["自收类", "代收类"],
      ruleValidate: {
        ContractID: [
          { required: true, message: "合同ID必选", trigger: "blur" },
        ],
        PayWayType: [
          { required: true, message: "请选择收款方式", trigger: "blur" },
        ],
        NormalType: [
          { required: true, message: "请选择收款类型", trigger: "blur" },
        ],
        ShouTuiType: [
          { required: true, message: "选择收退状态", trigger: "blur" },
        ],
        XiaoXiang: [
          { required: true, message: "正确选择类型科目", trigger: "blur" },
        ],
        Money: [
          { required: true, message: "金额为必填项", trigger: "blur" },
          {
            type: "string",
            max: 11,
            pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
            message: "金额大于0，只精确到小数点后两位，最多11位",
            trigger: "blur",
          },
        ],
        TaxRate: [{ required: true, message: "税率为必填项", trigger: "blur" }],
        Agent: [{ required: true, message: "负责人不能为空", trigger: "blur" }],
        MoneyDate: [
          { required: true, message: "收支日期不能为空", trigger: "blur" },
        ],
        PaperDate: [
          { required: true, message: "凭证日期不能为空", trigger: "blur" },
        ],
      },
      d_total: 0,
      d_search_key: [
        {
          value: "p.ID",
          label: "费用编号",
        },
        {
          value: "c.Name",
          label: "合同名称",
        },
        {
          value: "p.ShouTuiType",
          label: "收退类型",
        },
        {
          value: "p.NormalType",
          label: "收款类型",
        },
        {
          value: "p.Xiaoxiang",
          label: "小项",
        },
        {
          value: "p.Yue",
          label: "余额",
        },
        {
          value: "p.Money",
          label: "金额",
        },
        {
          value: "p.PayWayType",
          label: "收款方式",
        },
        {
          value: "p.MoneyDate",
          label: "收支日期",
        },
        {
          value: "p.PaperDate",
          label: "凭证日期",
        },
        {
          value: "p.Notes",
          label: "备注",
        },
        {
          value: "p.ContractID",
          label: "合同编号",
        },
      ],
      d_modal_add: false,
      d_modal_title: "",
      d_columns: [
        {
          title: "费用编号",
          key: "ID",
          width: 140,
          fixed: "left",
        },
        {
          title: "所属合同",
          key: "ContractName",
          width: 100,
        },
        {
          title: "小项",
          key: "XiaoXiang",
          width: 100,
        },
        {
          title: "收款方式",
          key: "PayWayType",
          width: 100,
        },
        {
          title: "收款类型",
          key: "NormalType",
          width: 100,
        },
        {
          title: "收款退款",
          key: "ShouTuiType",
          width: 100,
        },
        {
          title: "金额",
          key: "Money",
          width: 120,
          render: (h, params) => {
            return h("span", params.row.Money + " 元");
          },
        },
        {
          title: "余额",
          key: "Yue",
          width: 120,
          render: (h, params) => {
            return h("span", params.row.Yue + " 元");
          },
        },
        {
          title: "是否已开票",
          key: "IsInvoice",
          width: 100,
        },
        {
          title: "负责人",
          key: "Agent",
          width: 100,
        },
        {
          title: "收支日期",
          key: "MoneyDate",
          width: 100,
        },
        {
          title: "凭证日期",
          key: "PaperDate",
          width: 100,
        },
        {
          title: "备注",
          key: "Notes",
        },
        {
          title: "操作",
          key: "do",
          fixed: "right",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.to_edit(params.row.ID);
                    },
                  },
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "提示",
                        content: "<p>您确认要删除该条数据吗？</p>",
                        onOk: () => {
                          this.to_delete(params.row.ID);
                        },
                      });
                    },
                  },
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.to_detail(params.row);
                    },
                  },
                },
                "查看"
              ),
            ]);
          },
        },
      ],
      d_data: [],
      d_modal_type: "",
      d_defaultList_ID: [],
      d_img_visible: false,
      d_img_name: "",
      d_del_data: "",
      d_modal_contract: false,
      d_columns_contract: [
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "合同编号",
          key: "SerialNum",
        },
        {
          title: "合同名称",
          key: "Name",
        },
      ],
      d_data_contract: [],
      d_search_key_contract: [
        {
          value: "c.ID",
          label: "编号",
        },
        {
          value: "c.Name",
          label: "姓名",
        },
        {
          value: "c.Address",
          label: "地址",
        },
      ],
      contract_params: {},
      d_cycle_list: [
        {
          value: "日付",
          label: "日付",
        },
        {
          value: "月付",
          label: "月付",
        },
        {
          value: "季付",
          label: "季付",
        },
        {
          value: "年付",
          label: "年付",
        },
      ],
      d_NormalType_arr: ["正常", "挂账", "补账"],
      d_PayWayType_list: ["银行", "现金", "POS", "其他"],
      d_data_detail: [],
      d_modal_detail: false,
      d_detail_file: "",
      d_rate_list: [],
    };
  },
  methods: {
    change_LastPayDate(date) {
      this.params.CondList[0].Value = date;
    },
    // changeNormalType(val){
    //   if(val==='挂账'){
    //     this.XiaoXiangFather = '代收类';
    //    this.change_xiaoxiangFather('代收类');
    //    this.add_params.IsInvoice='否'
    //   }
    // },
    change_xiaoxiangFather(val) {
      let billType = this.$store.state.app.billType;
      if (val === "自收类") {
        this.d_XiaoXiang_arr = billType.selfRent.concat(billType.self2);
      } else {
        this.d_XiaoXiang_arr = billType.instead;
      }
      this.add_params.XiaoXiang = this.d_XiaoXiang_arr[0].value;
    },
    change_date_paper(date) {
      this.add_params.PaperDate = date;
    },
    change_date_money(date) {
      this.add_params.MoneyDate = date;
    },
    to_openContract() {
      this.d_modal_contract = true;
    },
    change_condList_contract(value) {
      if (value == "c.ID") {
        this.contract_params.CondList[0].Operator = "=";
      } else {
        this.contract_params.CondList[0].Operator = "like";
      }
    },
    search_contract() {
      this.contract_params.PageIndex = 1;
      this.pull_data_contract();
    },
    pull_Rate_data() {
      apiSystem.getList.post().then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          //登录成功+执行成功
          let rowsList = _data.data.Data.RowsList;
          for (let i = 0; i < rowsList.length; i++) {
            if (rowsList[i].Name === "TaxRate") {
              let arrValue = rowsList[i].Value.split(",");
              this.d_rate_list = arrValue;
            }
          }
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    pull_data_contract() {
      let _this = this;
      apiContract.getList.post(this.contract_params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let RowsList = requestResult.RowsList;
          if (RowsList.length > 0) {
            for (let i = 0; i < RowsList.length; i++) {
              if (this.add_params.ContractID === RowsList[i].SerialNum) {
                RowsList[i]._highlight = true;
              }
            }
            _this.d_data_contract = RowsList;
          } else {
            sessionStorage.setItem("contractInfo", "");
          }
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    change_contract(currentRow) {
      this.d_modal_contract = false;
      this.add_params.ContractID = currentRow.SerialNum;
      this.add_params.ContractName = currentRow.Name;
      let contractInfo = {
        //前后两个界面都有用到，不要轻易删除
        CycleType: currentRow.CycleType,
        ShopIDs: currentRow.ShopIDs,
        SerialNum: currentRow.SerialNum,
        Name: currentRow.Name,
      };
      sessionStorage.setItem("contractInfo", JSON.stringify(contractInfo));
    },
    change_condList(value) {
      if (
        value == "p.ID" ||
        value == "p.ContractID" ||
        value == "p.Notes" ||
        value == "c.Name"
      ) {
        this.params.CondList[0].Operator = "like";
      } else if (
        value == "p.ShouTuiType" ||
        value == "p.Xiaoxiang" ||
        value == "p.PayWayType" ||
        value == "p.NormalType"
      ) {
        this.params.CondList[0].Operator = "=";
      } else {
        this.params.CondList[0].Operator = ">=";
      }
    },
    search() {
      this.params.PageIndex = 1;
      this.pull_data();
    },
    flip(page) {
      //翻页条件，每页多少条，多少页
      this.params.PageIndex = page;
      this.pull_data();
    },
    change_size(size) {
      //改变limit 每页显示多少条
      this.params.PageSize = size;
      this.pull_data();
    },
    pull_data() {
      let _this = this;
      if (this.params.CondList[0].Key === "c.Name") {
        sessionStorage.setItem("cName", this.params.CondList[0].Value);
      }
      apiPay.getList.post(this.params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let rowsList = requestResult.RowsList;
          for (let i = 0; i < rowsList.length; i++) {
            rowsList[i].MoneyDate = _this.to_date(rowsList[i].MoneyDate);
            rowsList[i].PaperDate = _this.to_date(rowsList[i].PaperDate);
          }
          _this.d_total = requestResult.Total;
          _this.d_data = rowsList;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    to_add() {
      this.d_modal_add = true;
      this.d_modal_type = "add";
      this.d_modal_title = "添加费用";
      this.add_params = JSON.parse(JSON.stringify(apiPay.add.data));
      let contractInfo = sessionStorage.getItem("contractInfo");
      if (contractInfo) {
        let contractInfoZ1 = JSON.parse(contractInfo);
        this.add_params.ContractID = contractInfoZ1.SerialNum;
        this.add_params.ContractName = contractInfoZ1.Name;
      }
      this.pull_data_contract();
    },
    to_edit(_id) {
      //余额和金额相等才能编辑
      this.d_modal_type = "edit";
      this.d_modal_title = "修改费用";
      apiPay.getEditDto(_id).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.add_params = JSON.parse(JSON.stringify(_data.data.Data));
          this.add_params.MoneyDate = this.to_date(this.add_params.MoneyDate);
          this.add_params.PaperDate = this.to_date(this.add_params.PaperDate);
          this.add_params.Money = Math.abs(Number(this.add_params.Money)) + "";
          this.add_params.TaxRate = this.add_params.TaxRate + "";
          let fileList = this.add_params.FileList;
          let defaultList = [];
          for (let i = 0; i < fileList.length; i++) {
            let thisFile = {};
            thisFile.name = fileList[i].SaveName;
            thisFile.url = fileList[i].SaveName;
            defaultList.push(thisFile);
          }
          this.d_defaultList_ID = defaultList;

          let billType = this.$store.state.app.billType; //给xiaoxiang的father赋值
          let billTypeSelf = billType.selfRent
            .concat(billType.self2)
            .map((item) => item.value);
          let billTypeInstead = billType.instead.map((item) => item.value);
          if (billTypeSelf.indexOf(this.add_params.XiaoXiang) > -1) {
            this.XiaoXiangFather = "自收类";
            this.d_XiaoXiang_arr = billType.selfRent.concat(billType.self2);
          }
          if (billTypeInstead.indexOf(this.add_params.XiaoXiang) > -1) {
            this.XiaoXiangFather = "代收类";
            this.d_XiaoXiang_arr = billType.instead;
          }
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
      this.d_modal_add = true;
    },
    to_date(date) {
      let moment = require("moment");
      return moment(date).format("YYYY-MM-DD");
    },
    add_modal_cancel() {
      this.d_modal_add = false;
    },
    edit_confirm(name) {
      let _this = this;
      this.add_params.FileList = [];
      let IDImgList = this.$refs.IDImgList.fileList;
      let fileList = [];
      if (IDImgList.length > 0) {
        for (let i = 0; i < IDImgList.length; i++) {
          let currFile = {};
          currFile.OutType = "pay";
          currFile.Type = "费用票据附件";
          if (IDImgList[i].response) {
            currFile.SaveName = IDImgList[i].response.Data;
          } else {
            currFile.SaveName = IDImgList[i].name;
          }
          fileList.push(currFile);
        }
      }
      this.add_params.FileList = fileList;
      this.add_params.Yue = this.add_params.Money; //余额必须和金额相等
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.submit_edit_data();
        } else {
          this.$Message.error("验证失败!");
        }
      });
    },
    submit_edit_data() {
      let _this = this;
      // if(this.add_params.Type =='支出'){
      //   this.add_params.Money = '-'+ this.add_params.Money;
      // }
      this.add_params.TaxRate = this.add_params.TaxRate;
      this.add_params.Money = this.add_params.Money;
      if (_this.d_modal_type == "add") {
        apiPay.add.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.d_modal_add = false;
            this.$refs.IDImgList.clearFiles(); //不知道这句话在这里是否有用
            this.pull_data();
          } else {
            this.$Message.error(_data.data.Msg);
          }
        });
      } else if (_this.d_modal_type == "edit") {
        apiPay.edit.post(this.add_params).then((_data) => {
          if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
            this.d_modal_add = false;
            this.$refs.IDImgList.clearFiles();
            this.pull_data();
          } else {
            this.$Message.error(_data.data.Msg);
          }
        });
      }
    },
    get_select_data(row) {
      let delData = "";
      for (let i = 0; i < row.length; i++) {
        delData += row[i].ID + ",";
      }
      delData =
        delData.substring(delData.length - 1) == ","
          ? delData.substring(0, delData.length - 1)
          : delData; // 去掉末尾逗号
      this.d_del_data = delData;
    },
    to_delete(_idList) {
      apiPay.del(_idList).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          this.$Message.success("删除成功");
          this.pull_data();
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
    img_preview_detail() {
      this.d_img_visible = true;
      this.d_img_name = this.d_detail_file;
    },
    to_detail(row) {
      apiPay.getEditDto(row.ID).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = JSON.parse(JSON.stringify(_data.data.Data));
          requestResult.MoneyDate = this.to_date(requestResult.MoneyDate);
          requestResult.PaperDate = this.to_date(requestResult.PaperDate);
          this.d_data_detail = requestResult;
          let fileList = this.d_data_detail.FileList;
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].Type == "费用票据附件" && fileList[i].SaveName) {
              apiPublic.downLoadFile(fileList[i].SaveName).then((_data) => {
                this.d_detail_file = URL.createObjectURL(_data.data);
              });
            }
          }
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
      //        图片赋值
      //        this.$refs['formValidate'].validate((valid)=> {}); //重新验证，不然会有提示
      this.d_modal_detail = true;
    },
  },
  created() {
    this.params = JSON.parse(JSON.stringify(apiPay.getList.data));
    this.params.CondList[0].Key = "c.Name";
    this.params.CondList[0].Operator = "like";
    this.params.CondList[0].Value = sessionStorage.getItem("cName") || "";
    this.add_params = JSON.parse(JSON.stringify(apiPay.add.data));
    this.contract_params = JSON.parse(JSON.stringify(apiContract.getList.data));
    this.pull_data();
    this.pull_Rate_data(); //获取所有税率
  },
  mounted() {
    // this.params.CondList[0].Key = 'p.ID';
    // this.params.CondList[0].Operator = 'like';

    this.token = sessionStorage.getItem("token");
    this.contract_params.PageIndex = 1;
    this.contract_params.PageSize = 100;
  },
};
</script>
<style scoped>
@import "../../../assets/css/table-list.css";
.form-title {
  line-height: 40px;
  text-indent: 10px;
  background-color: #f3f3f3;
  margin-bottom: 10px;
}
.margin-right10 {
  margin-right: 10px;
}
.detail-group section {
  margin-bottom: 14px;
}
.detail-group section label {
  margin-right: 15px;
}
.detail-group section label,
.detail-group section span {
  display: inline-block;
}
.tx-user {
  width: 50px;
  max-height: 100px;
}
</style>
<style>
.ivu-form-item-content {
  line-height: 33px;
}
</style>





















